import { Calendar, FileText, Package, Truck } from "lucide-react";
import { COLOR_AZUL_MAIN } from "../utils/const/colors-const";

function getRespuestaValue(respuestas, matcher) {
  const field = (Array.isArray(respuestas) ? respuestas : []).find((item) => {
    if (typeof matcher === "function") return matcher(item);
    return item?.type === matcher || item?.key === matcher;
  });
  const value = field?.value;
  if (value == null) return null;
  if (typeof value === "object") return value.label ?? null;
  return String(value);
}

export default function ProgramacionViajeCardComponent({
  item,
  acciones = [],
  onAccionClick,
  onClick,
  selected = false,
}) {
  const respuestas = item?.respuestasParsed ?? [];
  const vehiculo = getRespuestaValue(respuestas, "seleccione_vehiculo");
  const producto = getRespuestaValue(respuestas, "seleccione_producto");
  const cantidad = getRespuestaValue(respuestas, "input_cantidad");

  const handleClick = () => {
    if (typeof onClick === "function") {
      onClick(item);
    }
  };

  const handleAccion = (accion) => {
    if (typeof onAccionClick === "function") {
      onAccionClick(accion, item);
      return;
    }
    console.log("accion", accion, "item", item);
  };

  const accionesHabilitadas = (Array.isArray(acciones) ? acciones : []).filter(
    (accion) => accion?.habilitado !== 0
  );

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") handleClick();
      }}
      className={`w-full text-left bg-white border rounded-lg p-3 shadow-sm transition-all hover:shadow-md focus:outline-none focus:ring-2 focus:ring-offset-1 ${
        selected
          ? "border-blue-500 ring-2 ring-blue-200"
          : "border-gray-200 hover:border-gray-300"
      }`}
    >
      <div
        className="h-1 w-10 rounded-full mb-3"
        style={{ backgroundColor: COLOR_AZUL_MAIN }}
      />
      <div className="flex items-start gap-2 min-w-0">
        <FileText className="h-4 w-4 shrink-0 mt-0.5 text-gray-500" />
        <p className="text-sm font-semibold text-gray-900 leading-snug break-words">
          {item?.formularioViaje ?? "—"}
        </p>
      </div>
      <div className="flex items-center gap-2 mt-2 min-w-0">
        <Calendar className="h-3.5 w-3.5 shrink-0 text-gray-400" />
        <p className="text-xs text-gray-500 truncate">{item?.fechaProceso ?? "—"}</p>
      </div>
      {vehiculo ? (
        <div className="flex items-center gap-2 mt-1.5 min-w-0">
          <Truck className="h-3.5 w-3.5 shrink-0 text-gray-400" />
          <p className="text-xs text-gray-600 truncate">{vehiculo}</p>
        </div>
      ) : null}
      {producto ? (
        <div className="flex items-start gap-2 mt-1.5 min-w-0">
          <Package className="h-3.5 w-3.5 shrink-0 mt-0.5 text-gray-400" />
          <p className="text-xs text-gray-600 leading-snug break-words">
            {producto}
            {cantidad ? ` · ${cantidad}` : ""}
          </p>
        </div>
      ) : null}
      {accionesHabilitadas.length > 0 ? (
        <div className="flex flex-wrap justify-end gap-2 mt-3 pt-2 border-t border-gray-100">
          {accionesHabilitadas.map((accion) => (
            <button
              key={accion.id}
              type="button"
              className="inline-flex items-center justify-center min-h-8 px-3 rounded text-xs font-semibold text-white hover:opacity-90"
              style={{ backgroundColor: accion.color || COLOR_AZUL_MAIN }}
              onClick={(event) => {
                event.stopPropagation();
                handleAccion(accion);
              }}
            >
              {accion.descripcion ?? "—"}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
